export default __webpack_public_path__ + "static/media/nav-book.98e0b8b2.svg";